import React, { ChangeEvent } from 'react';

import { TextField } from '@mui/material';
import { MuiInputProps } from './input-types';

export const MuiInput: React.FC<MuiInputProps> = ({
  onChangeValue,
  readonly,
  ...rest
}) => {
  const onChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ): void => {
    onChangeValue(event.target.name, event.target.value);
  };

  return (
    <TextField
      {...rest}
      fullWidth
      onChange={onChange}
    />
  );
};
